import React from 'react'
import { Container } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import ServicesContainer from '../components/Services/ServicesContainer';

    class Services extends React.Component {

      componentDidMount = () => {
        this.props.log('Services.js/componentDidMount');
      }
    
      render() {
        return (<Container fluid>
          <ServicesContainer {...this.props}/>
        </Container>
        );
      }
    }

export default Services;